import { useStore } from 'vuex';

export const menuItems = [
  {
    id: 1,
    label: 'menuItems.integrations.title',
    isTitle: true,
  },
  {
    id: 2,
    label: 'menuItems.integrations.sources.title',
    icon: 'bx-log-in-circle',
    subItems: [
      {
        id: 20,
        label: 'menuItems.integrations.sources.list.overview',
        link: { name: 'source-overview' },
        parentId: 2,
      },
      {
        id: 21,
        label: 'menuItems.integrations.sources.list.sourcesCatalog',
        link: { name: 'source-catalog' },
        parentId: 2,
      },
      {
        id: 22,
        label: 'menuItems.integrations.sources.list.containers',
        link: { name: 'containers' },
        parentId: 2,
        contextualSubItems: [
          {
            id: 220,
            label: () => {
              const store = useStore();
              return store?.state.tms?.webContainer?.entity?.name ?? '_';
            },
            isTitle: true,
            isBranchMode: true,
            bagdeColor: () => {
              const store = useStore();
              return store.getters['tms/webContainer/isBranch'] ? 'badge-blue' : 'badge-red';
            },
            parentId: 22,
          },
          {
            id: 221,
            label: 'menuItems.containers.tagsConfiguration',
            icon: 'bx-tag',
            parentId: 22,
            subItems: [
              {
                id: 2210,
                label: 'menuItems.containers.overview',
                link: { name: 'tags-overview' },
                dataTestId: 'web-tags-overview',
                parentId: 221,
              },
              {
                id: 2211,
                label: 'menuItems.containers.edition',
                link: { name: 'web-containers-edit' },
                parentId: 221,
              },
              {
                id: 2212,
                label: 'menuItems.containers.catalog',
                link: { name: 'tags-catalog' },
                parentId: 221,
              },
            ],
          },
          {
            id: 222,
            parentId: 22,
            label: 'menuItems.containers.containerEdition',
            icon: 'bx-globe',
            forcedOpened: true,
            subItems: [
              {
                id: 2220,
                label: 'menuItems.containers.test',
                link: { name: 'web-containers-test' },
                parentId: 222,
              },
              {
                id: 2221,
                label: 'menuItems.containers.generate',
                link: { name: 'tag-container-generate' },
                parentId: 222,
              },
              {
                id: 2222,
                label: 'menuItems.containers.deploy',
                link: { name: 'tag-container-deploy' },
                parentId: 222,
              },
              {
                id: 2223,
                label: 'menuItems.containers.customJs',
                link: { name: 'tag-custom-js' },
                parentId: 222,
              },
              {
                id: 2224,
                label: 'menuItems.containers.containerSettings',
                link: { name: 'container-settings' },
                parentId: 222,
              },
              {
                id: 2225,
                label: 'menuItems.integrations.sources.list.inspector',
                link: { name: 'tag-sources-inspector' },
                parentId: 222,
              },
            ],
          },
          {
            id: 223,
            parentId: 22,
            label: 'menuItems.containers.rules',
            icon: 'bx-filter-alt',
            subItems: [
              {
                id: 2230,
                label: 'menuItems.containers.rulesSummary',
                link: { name: 'tag-rules-summary' },
                parentId: 223,
              },
              {
                id: 2231,
                label: 'menuItems.containers.triggers',
                link: { name: 'tag-triggers' },
                parentId: 223,
              },
              {
                id: 2232,
                label: 'menuItems.containers.perimeters',
                link: { name: 'tag-perimeters' },
                parentId: 223,
              },
              {
                id: 2233,
                label: 'menuItems.containers.constraints',
                link: { name: 'tag-constraints' },
                parentId: 223,
              },
              {
                id: 2234,
                label: 'menuItems.containers.deduplication',
                link: { name: 'tag-deduplications' },
                parentId: 223,
              },
              {
                id: 2235,
                label: 'menuItems.containers.privacyConstraints',
                link: { name: 'tag-privacy-constraints' },
                parentId: 223,
              },
            ],
          },
          {
            id: 224,
            parentId: 222,
            label: 'menuItems.containers.common',
            icon: 'bx-cog',
            subItems: [
              {
                id: 2240,
                label: 'menuItems.containers.webDatalayer',
                link: { name: 'tag-web-datalayer' },
                parentId: 224,
              },
              {
                id: 2241,
                label: 'menuItems.configure.admin.list.copy',
                link: { name: 'tag-copy-management' },
                parentId: 224,
              },
              {
                id: 2242,
                label: 'menuItems.configure.admin.list.history',
                link: { name: 'tag-modification-history' },
                parentId: 2107,
              },
              {
                id: 2243,
                label: 'menuItems.configure.dataGovernance.list.tagDataSharing',
                link: { name: 'source-tag-data-sharing' },
                parentId: 224,
              },
              {
                id: 2244,
                label: 'menuItems.integrations.health.list.containerStats',
                link: { name: 'tag-web-container-stats' },
                parentId: 224,
              },
              {
                id: 2245,
                label: 'menuItems.integrations.health.list.tagsPerf',
                link: { name: 'tag-tags-performance' },
                parentId: 224,
              },
              {
                id: 2246,
                label: 'menuItems.integrations.health.list.piggybacking',
                link: { name: 'tag-piggybacking' },
                parentId: 224,
              },
            ],
          },
        ],
      },
      {
        id: 23,
        label: 'menuItems.integrations.sources.list.privacy',
        link: { name: 'privacy-banners' },
        parentId: 2,
        contextualSubItems: [
          {
            id: 230,
            label: () => {
              const store = useStore();
              return store?.state.privacy?.privacyBanners?.entity?.label ?? '_';
            },
            isTitle: true,
            parentId: 23,
          },
          {
            id: 231,
            label: 'menuItems.privacyBanners.list.bannerConfiguration',
            icon: 'bx-globe',
            forcedOpened: true,
            parentId: 23,
            subItems: [
              {
                id: 2311,
                label: 'menuItems.privacyBanners.list.edition',
                link: { name: 'privacy-banners-edition' },
                parentId: 231,
              },
              {
                id: 2312,
                label: 'menuItems.privacyBanners.list.generateOrDeploy',
                link: { name: 'privacy-banners-deploy' },
                parentId: 231,
              },
            ],
          },
          {
            id: 232,
            label: 'menuItems.privacyBanners.list.reports',
            icon: 'bx-bar-chart',
            forcedOpened: true,
            parentId: 23,
            subItems: [
              {
                id: 2321,
                label: 'menuItems.privacyBanners.list.consentAnalysis',
                link: { name: 'consent-dashboard-privacy-banners' },
                parentId: 232,
              },
              {
                id: 2322,
                label: 'menuItems.privacyBanners.list.cookieScanner',
                link: { name: 'privacy-banners-cookie-scanner' },
                parentId: 232,
              },
              {
                id: 2323,
                label: 'menuItems.privacyBanners.list.piggybacking',
                link: { name: 'privacy-banners-piggybacking' },
                parentId: 232,
              },
            ],
          },
          {
            id: 233,
            label: 'menuItems.privacyBanners.list.consentManagement',
            icon: 'bx-shield',
            forcedOpened: true,
            parentId: 23,
            subItems: [
              {
                id: 2331,
                label: 'menuItems.privacyBanners.list.consentCategories',
                link: { name: 'privacy-banners-consent-categories' },
                parentId: 233,
              },
              {
                id: 2332,
                label: 'menuItems.privacyBanners.list.vendorSettings',
                link: { name: 'privacy-banners-vendor-settings' },
                parentId: 233,
              },
              {
                id: 2333,
                label: 'menuItems.privacyBanners.list.tagAssignation',
                link: { name: 'privacy-banners-tag-assignation' },
                parentId: 233,
              },
              {
                id: 2334,
                label: 'menuItems.privacyBanners.list.consentSettings',
                link: { name: 'privacy-banners-consent-settings' },
                parentId: 233,
              },
            ],
          },
        ],
      },
      {
        id: 24,
        label: 'menuItems.integrations.sources.list.inspector',
        link: { name: 'sources-inspector' },
        parentId: 2,
      },
      {
        id: 25,
        label: 'menuItems.integrations.sources.list.adTrafficking',
        link: { name: 'trafficking' },
        parentId: 2,
      },
    ],
  },
  {
    id: 3,
    label: 'menuItems.integrations.enrichments.title',
    icon: 'bx-layer-plus',
    subItems: [
      {
        id: 30,
        label: 'menuItems.integrations.enrichments.list.event.title',
        link: { name: 'event-enrichment-overview' },
        parentId: 3,
      },
      {
        id: 31,
        label: 'menuItems.integrations.enrichments.list.user',
        link: { name: 'user-attributes' },
        parentId: 3,
      },
    ],
  },
  {
    id: 4,
    label: 'menuItems.integrations.destinations.title',
    icon: 'bx-log-out-circle bx-flip-horizontal',
    subItems: [
      {
        id: 40,
        label: 'menuItems.integrations.destinations.list.overview',
        link: { name: 'destination-overview' },
        parentId: 4,
      },
      {
        id: 41,
        label: 'menuItems.integrations.destinations.list.catalog',
        link: { name: 'destination-catalog' },
        parentId: 4,
      },
      {
        id: 42,
        label: 'menuItems.integrations.destinations.list.campaignExport',
        link: { name: 'campaign-exports' },
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    label: 'menuItems.integrations.health.title',
    icon: 'bx-pulse',
    subItems: [
      {
        id: 50,
        label: 'menuItems.integrations.health.list.sourcesDataQuality',
        link: { name: 'sources-data-quality' },
        parentId: 5,
      },
      {
        id: 51,
        label: 'menuItems.integrations.health.list.destinationsMonitoring',
        link: { name: 'integrations-monitoring' },
        parentId: 5,
      },
      {
        id: 52,
        label: 'menuItems.integrations.health.list.websiteMonitoring',
        parentId: 5,
        subItems: [
          {
            id: 520,
            label: 'menuItems.integrations.health.list.datalayer',
            link: '/todo',
            parentId: 52,
          },
          {
            id: 521,
            label: 'menuItems.integrations.health.list.cookieScanner',
            link: { name: 'trust-cookie-scanner-edit' },
            parentId: 52,
          },
          {
            id: 522,
            label: 'menuItems.integrations.health.list.tagsPerf',
            link: { name: 'tags-performance' },
            parentId: 52,
          },
          {
            id: 523,
            label: 'menuItems.integrations.health.list.piggybacking',
            link: { name: 'piggybacking' },
            parentId: 52,
          },
          {
            id: 524,
            label: 'menuItems.integrations.health.list.containerStats',
            link: { name: 'web-container-stats' },
            parentId: 52,
          },
          {
            id: 525,
            label: 'menuItems.integrations.health.list.dedupConversions',
            link: { name: 'deduplication-by-conversions' },
            parentId: 52,
          },
          {
            id: 526,
            label: 'menuItems.integrations.health.list.dedupTags',
            link: { name: 'deduplication-by-tags' },
            parentId: 52,
          },
        ],
      },
      {
        id: 53,
        label: 'menuItems.integrations.health.list.alerts',
        link: '/todo',
        parentId: 5,
      },
    ],
  },
  {
    id: 6,
    label: 'menuItems.customers.title',
    isTitle: true,
  },
  {
    id: 7,
    label: 'menuItems.customers.segments.title',
    icon: 'bx-bullseye',
    subItems: [
      {
        id: 70,
        label: 'menuItems.customers.segments.list.overview',
        link: { name: 'segments' },
        parentId: 7,
      },
      {
        id: 71,
        label: 'menuItems.customers.segments.list.stats',
        link: { name: 'segment-stats' },
        parentId: 7,
      },
      {
        id: 72,
        label: 'menuItems.customers.segments.list.overlap',
        link: { name: 'segment-overlap' },
        parentId: 7,
      },
      {
        id: 73,
        label: 'menuItems.customers.segments.list.dashboard',
        link: { name: 'segment-dashboard' },
        parentId: 7,
      },
    ],
  },
  {
    id: 8,
    label: 'menuItems.customers.identities.title',
    link: { name: 'fuse-activation' },
    icon: 'bx-fingerprint',
    subItems: [
      {
        id: 73,
        label: 'menuItems.customers.identities.activation',
        link: { name: 'fuse-activation' },
        parentId: 8,
      },
      {
        id: 73,
        label: 'menuItems.customers.identities.migration',
        link: { name: 'fuse-migration' },
        parentId: 8,
      },
      {
        id: 74,
        label: 'menuItems.customers.identities.statistics',
        link: { name: 'fuse-statistics' },
        parentId: 8,
      },
    ],
  },
  {
    id: 9,
    label: 'menuItems.explore.title',
    isTitle: true,
  },
  {
    id: 10,
    label: 'menuItems.explore.insights.list.campaign.title',
    icon: 'bx-bar-chart',
    subItems: [
      {
        id: 100,
        label: 'menuItems.explore.insights.list.campaign.list.controlgroup',
        link: { name: 'campaign-performance-dashboard' },
        parentId: 10,
        dontDisplayPadlockIfNoAccess: true,
      },
      {
        id: 101,
        label: 'menuItems.explore.insights.list.campaign.list.lrb',
        link: { name: 'live-report-builder' },
        parentId: 10,
      },
      {
        id: 105,
        label: 'menuItems.explore.insights.list.campaign.list.allChannels',
        link: { name: 'all-channels' },
        parentId: 10,
      },
      {
        id: 102,
        label: 'menuItems.explore.insights.list.campaign.list.contributive',
        link: { name: 'contributive-analysis' },
        parentId: 10,
      },
      {
        id: 103,
        label: 'menuItems.explore.insights.list.campaign.list.conversions.title',
        parentId: 10,
        subItems: [
          {
            id: 1031,
            label: 'menuItems.explore.insights.list.campaign.list.conversions.conversionDetails',
            link: { name: 'conversion-details' },
            parentId: 103,
          },
          {
            id: 1033,
            label: 'menuItems.explore.insights.list.campaign.list.conversions.customerJourney',
            link: { name: 'customer-journey' },
            parentId: 103,
          },
          {
            id: 1032,
            label: 'menuItems.explore.insights.list.campaign.list.conversions.overlap',
            link: { name: 'campaign-overlap' },
            parentId: 103,
          },
        ],
      },
      {
        id: 104,
        label: 'menuItems.explore.insights.list.campaign.list.sunburst',
        link: { name: 'sunburst' },
        parentId: 10,
      },
      {
        id: 106,
        label: 'menuItems.explore.insights.list.campaign.specific.disney.otd',
        link: { name: 'disney-otd' },
        parentId: 10,
        siteId: ['476'],
      },
      {
        id: 106,
        label: 'menuItems.explore.insights.list.campaign.specific.disney.partners',
        link: { name: 'disney-partners' },
        parentId: 10,
        siteId: ['476'],
      },
    ],
  },
  {
    id: 11,
    label: 'menuItems.explore.consent',
    icon: 'bx-check-shield',
    link: { name: 'consent-dashboard' },
  },
  {
    id: 12,
    label: 'menuItems.configure.title',
    isTitle: true,
  },
  {
    id: 13,
    label: 'menuItems.configure.data.title',
    icon: 'bx-layer',
    subItems: [
      {
        id: 130,
        label: 'menuItems.configure.data.list.eventsCollection',
        link: { name: 'events-collection' },
        parentId: 13,
      },
      {
        id: 131,
        label: 'menuItems.configure.data.list.dataCleansing',
        link: { name: 'cleansing-transformation-overview' },
        parentId: 13,
      },
      {
        id: 132,
        label: 'menuItems.configure.data.list.dataSpecification.title',
        parentId: 13,
        subItems: [
          {
            id: 1321,
            label: 'menuItems.configure.data.list.dataSpecification.eventSpec',
            link: { name: 'normalized-datalayer' },
            badge: { text: 'NEW', variant: 'primary' },
            parentId: 132,
          },
          {
            id: 1322,
            label: 'menuItems.configure.data.list.dataSpecification.web',
            link: { name: 'web-datalayer' },
            parentId: 132,
          },
        ],
      },
      {
        id: 134,
        label: 'menuItems.configure.data.list.pii',
        link: '/todo',
        parentId: 13,
      },
      {
        id: 136,
        label: 'menuItems.configure.data.list.campaignSettings.title',
        parentId: 13,
        subItems: [
          {
            id: 1351,
            label: 'menuItems.configure.data.list.campaignSettings.channelIdentification',
            link: { name: 'channel-identification' },
            parentId: 135,
          },
          {
            id: 1352,
            label: 'menuItems.configure.data.list.campaignSettings.ip',
            link: { name: 'ip' },
            parentId: 135,
          },
          {
            id: 1353,
            label: 'menuItems.configure.data.list.campaignSettings.dimensions',
            link: { name: 'dimensions' },
            parentId: 135,
          },
          {
            id: 1354,
            label: 'menuItems.configure.data.list.campaignSettings.cost',
            link: { name: 'cost' },
            parentId: 135,
          },
          {
            id: 1355,
            label: 'menuItems.configure.data.list.campaignSettings.transformEntities',
            link: { name: 'transform-entities' },
            parentId: 135,
          },
          {
            id: 1356,
            label: 'menuItems.configure.data.list.campaignSettings.customerJourney',
            link: { name: 'customer-journey-options' },
            parentId: 135,
          },
          {
            id: 1357,
            label: 'menuItems.configure.data.list.campaignSettings.redirectRules',
            link: { name: 'redirect-rules' },
            parentId: 135,
          },
          {
            id: 1358,
            label: 'menuItems.configure.data.list.campaignSettings.attribution',
            link: { name: 'attribution-models' },
            parentId: 135,
          },
          {
            id: 1359,
            label: 'menuItems.configure.data.list.campaignSettings.segmentation',
            link: { name: 'segmentation' },
            parentId: 135,
          },
          {
            id: 13510,
            label: 'menuItems.configure.data.list.campaignSettings.exchangeRate',
            link: { name: 'exchange-rate' },
            parentId: 135,
          },
        ],
      },
    ],
  },
  {
    id: 15,
    label: 'menuItems.configure.dataGovernance.title',
    icon: 'bx-shield-quarter',
    subItems: [
      {
        id: 150,
        label: 'menuItems.configure.dataGovernance.list.piiData',
        link: '/todo',
        parentId: 15,
      },
      {
        id: 151,
        label: 'menuItems.configure.dataGovernance.list.consent.title',
        parentId: 15,
        subItems: [
          {
            id: 1510,
            label: 'menuItems.configure.dataGovernance.list.consent.list.categories',
            link: { name: 'consent-categories' },
            parentId: 151,
          },
          {
            id: 1511,
            label: 'menuItems.configure.dataGovernance.list.consent.list.vendors',
            link: { name: 'vendor-settings' },
            parentId: 151,
          },
          {
            id: 1512,
            label: 'menuItems.configure.dataGovernance.list.consent.list.settings',
            link: { name: 'consent-settings' },
            parentId: 151,
          },
        ],
      },
      {
        id: 152,
        label: 'menuItems.configure.dataGovernance.list.storageSettings',
        link: { name: 'storage-settings-overview' },
        parentId: 15,
      },
      {
        id: 153,
        label: 'menuItems.configure.dataGovernance.list.storageInspector',
        link: { name: 'storage-inspector' },
        parentId: 15,
      },
      {
        id: 153,
        label: 'menuItems.configure.dataGovernance.list.tagDataSharing',
        link: { name: 'tag-data-sharing' },
        parentId: 15,
      },
    ],
  },
  {
    id: 14,
    label: 'menuItems.configure.admin.title',
    icon: 'bx-wrench',
    subItems: [
      {
        id: 140,
        label: 'menuItems.configure.admin.list.history',
        link: { name: 'modification-history' },
        parentId: 14,
      },
      {
        id: 141,
        label: 'menuItems.configure.admin.list.user',
        link: { name: 'user-management' },
        parentId: 14,
      },
      {
        id: 142,
        label: 'menuItems.configure.admin.list.profile',
        link: { name: 'profile-management' },
        parentId: 14,
      },
      {
        id: 143,
        label: 'menuItems.configure.admin.list.connector',
        link: { name: 'connector-management' },
        parentId: 14,
      },
      {
        id: 144,
        label: 'menuItems.configure.admin.list.domain',
        link: { name: 'domain-management' },
        parentId: 14,
      },
      {
        id: 1400,
        label: 'menuItems.configure.admin.list.jsHosting',
        link: { name: 'js-hosting-overview' },
        parentId: 14,
      },
      {
        id: 145,
        label: 'menuItems.configure.admin.list.copy',
        link: { name: 'copy-management' },
        parentId: 14,
      },
      {
        id: 146,
        label: 'menuItems.configure.admin.list.billing',
        link: { name: 'credit-usage' },
        parentId: 14,
      },
      {
        id: 148,
        label: 'menuItems.configure.admin.list.library',
        link: { name: 'library-management' },
        parentId: 14,
      },
      {
        id: 149,
        label: 'menuItems.configure.admin.list.disclaimer',
        link: { href: 'https://doc.commandersact.com/configure/disclaimer' },
        parentId: 14,
      },
      {
        id: 147,
        label: 'menuItems.configure.admin.list.backoffice.title',
        parentId: 14,
        icon: 'bx-wrench',
        backOffice: true,
        subItems: [
          {
            id: 1470,
            label: 'menuItems.configure.admin.list.backoffice.list.siteManager',
            link: { name: 'site-manager' },
            parentId: 147,
            backOffice: true,
          },
          {
            id: 1470,
            label: 'menuItems.configure.admin.list.backoffice.list.superusersBo',
            link: { name: 'superusers-bo' },
            parentId: 147,
            backOffice: true,
          },
          {
            id: 1471,
            label: 'menuItems.configure.admin.list.backoffice.list.templateImporter',
            link: { name: 'back-office-template-importer-overview' },
            parentId: 147,
            deployTemplate: true,
          },
          {
            id: 1472,
            label: 'menuItems.configure.admin.list.backoffice.list.campaignExportRaw',
            link: { name: 'raw-data' },
            parentId: 147,
            deployTemplate: true,
          },
        ],
      },
    ],
  },
];
